/**
 * PREVIEW COMPANY REDUX ACTIONS
 *
 * Description here.
 *
 * @version 0.1
 */

import reduxStore from './../../reduxStore';
import utils from './../../utils/utilities';
import xhr from './../../utils/xhr';

import headerActions from './../../reusable/Header/Header.actions';
import popupActions from './../../reusable/MessagePopup/redux/MessagePopup.actions';

import { POPUP_LIFETIME } from './../../constants';

import commonActions from './../../api/Common.actions';

// Define action constants
export const PREVIEW_INITIAL_PHASE = 'PREVIEW_INITIAL_PHASE';
export const PREVIEW_PARAMS_CLEAR = 'PREVIEW_PARAMS_CLEAR';
export const PREVIEW_UPDATE_COMPANY = 'PREVIEW_UPDATE_COMPANY';
export const POPULATE_NEXT_PREV = 'POPULATE_NEXT_PREV';
export const PREVIEW_TABLE_URL_CHANGE = 'PREVIEW_TABLE_URL_CHANGE';
export const CHANGE_COLUMN_WIDTHS = 'CHANGE_COLUMN_WIDTHS';
export const PREVIEW_TABLE_COUNT_CHANGE = 'PREVIEW_TABLE_COUNT_CHANGE';
export const PREVIEW_INACTIVE_ENTITIES_COUNT = 'PREVIEW_INACTIVE_ENTITIES_COUNT';

const actions = {

    resetPreviewToInitial: () => {
        reduxStore.dispatch({type: 'PREVIEW_INITIAL_PHASE'});
        headerActions.updateHeader('previewCompany');
    },

    changeColumnWidths: (columnWidths) => {
        reduxStore.dispatch({
            type: 'CHANGE_COLUMN_WIDTHS',
            payload: columnWidths
        });
    },

    changeTableUrlParams: (urlParams) => {
        reduxStore.dispatch({
            type:    PREVIEW_TABLE_URL_CHANGE,
            payload: urlParams
        });

        commonActions.updateUserPrefs({
                articlesLanguageFilter: urlParams.language,
                previewCompany: {
                    sortBy:    urlParams.sortBy,
                    direction: urlParams.direction,
                    riskAngle: urlParams.riskAngle,
                    riskLevel: urlParams.riskLevel
                }
            })
    },

    countShownEntries: (count, filterCount) => {
        reduxStore.dispatch({
            type:    PREVIEW_TABLE_COUNT_CHANGE,
            payload: {"count": count, "filterCount": filterCount}
        });
    },

    loadCompany: (companyId, noSpinner) => {

        if (!noSpinner) {
            reduxStore.dispatch({type: 'SHOW_SPINNER'});
        }

        return xhr.get({
            url: '/api/entities/company/' + companyId
        }).then((response) => {
            reduxStore.dispatch(
                {
                    type:    "LOAD_COMPANY_DATA",
                    payload: response.body
                }
            );

            if (!noSpinner) {
                reduxStore.dispatch({type: 'HIDE_SPINNER'});
            }
        }).catch((error) => {
            xhr.handleAllErrors(error);
        });
    },

    updateCompanyData: (newCompanyData) => {
        reduxStore.dispatch(
            {
                type:    PREVIEW_UPDATE_COMPANY,
                payload: newCompanyData
            }
        );
    },

    updateField: (companyData, labelsFieldName, labelValue) => {

        if (typeof companyData.id === 'string') {

            let companyId      = companyData.id,
                newCompanyData = utils.deepClone(companyData);

            newCompanyData[labelsFieldName] = labelValue;

            return xhr.put({
                url:  '/api/entities/company/' + companyId,
                data: newCompanyData
            }).then((response) => {
                reduxStore.dispatch(
                    {
                        type:    "LOAD_COMPANY_DATA",
                        payload: response.body
                    }
                );
            }).catch((error) => {
                if (error.status === 400) {

                    // Show error message of popup can not be shown.
                    popupActions.setMessages({
                        popupTitle: null,
                        messages:   [
                            {
                                messageId:   'previewCompanies.addingLabelError',
                                messageType: 'system-error'
                            }
                        ]
                    });

                    // Hide the message after 5 seconds.
                    setTimeout(popupActions.removeMessage, POPUP_LIFETIME);

                } else {
                    xhr.handleAllErrors(error);
                }
            });

        }

    },

    addLabel: (companyData, labelsFieldName, labelValue) => {

        if (typeof companyData.id === 'string') {

            let companyId      = companyData.id,
                newCompanyData = utils.deepClone(companyData);

            newCompanyData[labelsFieldName].push(labelValue);

            return xhr.put({
                url:  '/api/entities/company/' + companyId,
                data: newCompanyData
            }).then((response) => {
                reduxStore.dispatch(
                    {
                        type:    "LOAD_COMPANY_DATA",
                        payload: response.body
                    }
                );
            }).catch((error) => {
                if (error.status === 400) {

                    // Show error message of popup can not be shown.
                    popupActions.setMessages({
                        popupTitle: null,
                        messages:   [
                            {
                                messageId:   'previewCompanies.addingLabelError',
                                messageType: 'system-error'
                            }
                        ]
                    });

                    // Hide the message after 5 seconds.
                    setTimeout(popupActions.removeMessage, POPUP_LIFETIME);

                } else {
                    xhr.handleAllErrors(error);
                }
            });

        }

    },

    removeLabel: (companyData, labelsArrayName, labelIndex) => {

        if (typeof companyData.id === 'string') {

            let companyId      = companyData.id,
                newCompanyData = utils.deepClone(companyData);

            newCompanyData[labelsArrayName].splice(labelIndex, 1);

            return xhr.put({

                url:  '/api/entities/company/' + companyId,
                data: newCompanyData
            }).then((response) => {
                reduxStore.dispatch(
                    {
                        type:    "LOAD_COMPANY_DATA",
                        payload: response.body
                    }
                );
            }).catch((error) => {
                if (error.status === 400) {

                    // Show error message of popup can not be shown.
                    popupActions.setMessages({
                        popupTitle: null,
                        messages:   [
                            {
                                messageId:   'previewCompanies.labelDeleteError',
                                messageType: 'system-error'
                            }
                        ]
                    });

                    // Hide the message after 5 seconds.
                    setTimeout(popupActions.removeMessage, POPUP_LIFETIME);

                } else {
                    xhr.handleAllErrors(error);
                }
            });

        }

    },


    countEntries: (previewItems) => {

        if (previewItems) {
            reduxStore.dispatch({type: 'PREVIEW_INACTIVE_ENTITIES_COUNT', payload: previewItems});
        } else {
            xhr.get({
                url: '/api/entities/companies/non-active/count'
            }).then((response) => {
                reduxStore.dispatch({type: 'PREVIEW_INACTIVE_ENTITIES_COUNT', payload: response.body});
            }).catch((error) => {
                if (error.status === 400) {
                    utils.logError(error, 'PreviewCompanies.actions.countEntries(): ');
                } else {
                    xhr.handleAllErrors(error);
                }
            });

        }

    }

};

export default actions;


// WEBPACK FOOTER //
// ./src/scripts/pages/PreviewCompany/PreviewCompany.actions.js